import "./index.scss";
// import { $ } from "@olmokit/dom";

/**
 * Component: Products
 */
export function Products() {
  console.log("Products mounted.");
}
